export const logtoCookieKey = '_logto';
export const deviceFlowXsrfCookieKey = '_logto_device_flow_xsrf';
